import { Constants } from '../app.constants';

export class GuestUtils {
  public static registered(): boolean {
    return !!localStorage.getItem(Constants.LOCAL_STORAGE_USER_EMAIL);
  }
}
